import { Alert, Button, Typography } from "antd";
import React from "react";

import { logError } from "@utils/errorHandling";

const { Text } = Typography;

interface Props {
  children: React.ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class AppErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logError("AppErrorBoundary", error.message, {
      stack: error.stack,
      componentStack: errorInfo.componentStack,
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleRetry = () => {
    this.setState({ hasError: false, error: undefined });
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          padding: 24,
          background: "#f5f5f5",
        }}
      >
        <Alert
          message="Algo deu errado"
          description={
            <div>
              <Text>
                Ocorreu um erro inesperado na aplicação. Tente novamente ou
                recarregue a página.
              </Text>
              {this.state.error && (
                <pre
                  style={{
                    marginTop: 12,
                    padding: 8,
                    background: "#fafafa",
                    borderRadius: 4,
                    fontSize: 12,
                    maxHeight: 120,
                    overflow: "auto",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                >
                  {this.state.error.message}
                </pre>
              )}
              <div style={{ marginTop: 16, display: "flex", gap: 8 }}>
                <Button onClick={this.handleRetry}>Tentar novamente</Button>
                <Button type="primary" onClick={this.handleReload}>
                  Recarregar página
                </Button>
              </div>
            </div>
          }
          type="error"
          showIcon
          style={{ maxWidth: 600, width: "100%" }}
        />
      </div>
    );
  }
}
